import { functions } from './firebase';

export const addUser = (data) => {
  var addUser = functions.httpsCallable('addUser');
  return addUser(data);
}
export const updateUser = (data) => {
  var addUser = functions.httpsCallable('updatePassword');
  return addUser(data);
}
export const deleteUser = (data) => {
  var addUser = functions.httpsCallable('deleteUser');
  return addUser(data);
}
export const sendNotification = (data) => {
  var addUser = functions.httpsCallable('pushNotification');
  return addUser(data);
}




// WEBPACK FOOTER //
// ./src/firebase/functions.js